import { render, staticRenderFns } from "./transOrderlist.vue?vue&type=template&id=bb23c7f0"
import script from "./transOrderlist.vue?vue&type=script&lang=js"
export * from "./transOrderlist.vue?vue&type=script&lang=js"
import style0 from "./transOrderlist.vue?vue&type=style&index=0&id=bb23c7f0&prod&lang=stylus"
import style1 from "./transOrderlist.vue?vue&type=style&index=1&id=bb23c7f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports